function copyToClipboard (content, parent) {
  const el = document.createElement('textarea');
  el.value = content;
  document.getElementById(parent).appendChild(el);
  el.select();
  document.execCommand('Copy');
  document.getElementById(parent).removeChild(el);
}

// var el = document.createElement("INPUT");
// el.type="text";
// el.setAttribute("value", content);
// el.style="opacity: 0; position: absolute; top: -5000000";
// document.body.appendChild(el);
//
// el.select();
// document.execCommand('Copy');
// console.log("el", el);
// document.body.removeChild(el);

exports.copyClip = copyToClipboard;
